import React, { useEffect } from "react"
import PageMetaTags from "components/PageMetaTags"
import { Container, Row, Col } from "reactstrap"
import BreadcrumbTitle from "components/BreadcrumbTitle"
import { withRouter, generatePath } from "react-router-dom"
import { SaveButton } from "components/Buttons"
import TableComponent from "components/Table"
import { getListOfLists, resetListOfLists } from "store/actions"
import { connect } from "react-redux"
import { URL_PATHS } from "constants/index"

const ListOfList = ({
  history,
  getListOfLists,
  resetListOfLists,
  listOfLists,
  match,
}) => {
  const { event_id } = match?.params
  useEffect(() => {
    getListOfLists({
      all: true,
      page: 1,
      per_page: 15,
      event_id: event_id,
    })
    return () => {
      resetListOfLists()
    }
  }, [])

  const handlePageChange = page => {
    getListOfLists({
      page: page,
      per_page: 15,
      all: true,
      event_id: event_id,
    })
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <PageMetaTags title="Lists" />
        <Container fluid>
          <BreadcrumbTitle
            title="Lists"
            breadcrumbItems={[
              { title: "Dashboard" },
              {
                title: "Experience Reports",
                link: generatePath(URL_PATHS.EVENT_REPORTS, { id: event_id }),
              },
              { title: "Lists" },
            ]}
          />
          <Row className="d-flex justify-content-end">
            <Col xs="auto">
              <SaveButton
                type="button"
                color="light"
                content="Back"
                onClick={() => {
                  history.goBack()
                }}
              />
            </Col>
          </Row>
          <Row className="my-3">
            <Col>
              <TableComponent
                data={listOfLists?.data}
                columns={[
                  {
                    text: "id",
                    dataField: "id",
                    sort: true,
                    hidden: true,
                    formatter: (cellContent, item) => <>{item?.id}</>,
                  },
                  {
                    text: "Name",
                    dataField: "name",
                    formatter: (cellContent, item) => <>{item?.name}</>,
                  },
                  {
                    text: "Details",
                    dataField: "details",
                    isDummyField: true,
                    formatter: (cellContent, item) => (
                      <span
                        className="btn-link"
                        style={{ cursor: "pointer" }}
                        onClick={() =>
                          history.push(
                            generatePath(URL_PATHS.LIST_REPORTS, {
                              event_id: event_id,
                              feature_id: item?.id,
                            })
                          )
                        }
                      >
                        View
                      </span>
                    ),
                  },
                ]}
                paginationData={{
                  current_page: listOfLists?.current_page,
                  last_page: listOfLists?.last_page,
                  total_items: listOfLists?.total,
                  items_per_page: listOfLists?.per_page,
                  from: listOfLists?.from,
                  to: listOfLists?.to,
                  first_page: 1,
                }}
                onPageChange={handlePageChange}
              />
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  listOfLists: state.List.listOfLists,
})

const mapDispatchToProps = dispatch => ({
  getListOfLists: values => dispatch(getListOfLists(values)),
  resetListOfLists: () => dispatch(resetListOfLists()),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(ListOfList))
